import { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import classNames from 'classnames'
import { ICompanyBase } from '@/componentsV2/../types'
import { getFormattedAmount } from '@/componentsV2/../utils'
import { CompanyStatusListItem } from '@/componentsV2/atoms/CompanyStatusListItem'
import { CompanyLogoAndName } from '@/componentsV2/molecules/CompanyLogoAndName'
import { Badge } from '@/componentsV2/atoms/Badge'
import styles from './index.module.scss'

type Props = {
  company: ICompanyBase
}

export const JobContentSidebar: FC<Props> = observer(({ company }) => {
  const { t } = useTranslation(['companies-[id]', 'companies-users-[id]'])

  const className = classNames(styles.container, {
    [styles.containerWithAlert]: company?.companyMembers?.length === 0,
  })

  return (
    <div className={className}>
      <div className={styles.heading}>{t('会社情報')}</div>
      <div className={styles.company}>
        <CompanyLogoAndName company={company} size='lg' />
      </div>
      {!company?.isVc && company?.markets.length > 0 && (
        <div className={styles.content}>
          <div className={styles.label}>{t('カテゴリー')}</div>
          <div className={styles.badge}>
            {company?.markets.map((item) => (
              <Badge key={item.id} color='primary'>
                {item.name}
              </Badge>
            ))}
          </div>
        </div>
      )}
      {company?.url && <CompanyStatusListItem isLink href={company?.url} name='Website' value={company?.url} />}
      {!company?.isVc && (
        <>
          {company?.round && (
            <div className={styles.content}>
              <div className={styles.label}>{t('ステージ')}</div>
              <div className={styles.badge}>
                <Badge color='primary'>{company?.round.name}</Badge>
              </div>
            </div>
          )}
          <CompanyStatusListItem
            name={t('合計資金調達額')}
            value={getFormattedAmount(Number(company?.totalFundingAmount), company?.currencyUnit)}
          />
        </>
      )}
      <CompanyStatusListItem name={t('従業員数')} value={t(company?.companySize)} />
      <div className={styles.content}>
        <div className={styles.label}>{t('companies-users-[id]:所在地')}</div>
        <div className={styles.location}>
          {company?.locations.length === 0 && <span>{t('未選択')}</span>}
          {company?.locations.length > 0 &&
            company?.locations.map((location) => {
              return (
                <span className={styles.locationTag} key={location.slug}>
                  {location.name}
                </span>
              )
            })}
        </div>
      </div>
    </div>
  )
})
